import Image from 'next/image';
import awning from '../../assets/img/reviews/window-awning.svg';
import casement from '../../assets/img/reviews/window-casement.svg';
import doubleHung from '../../assets/img/reviews/window-double-hung.svg';
import picture from '../../assets/img/reviews/window-picture.svg';
import sliding from '../../assets/img/reviews/window-sliding.svg';
import specialty from '../../assets/img/reviews/window-specialty.svg';
import patio400Sliding from '../../assets/img/reviews/patio-400-sliding.svg';
import patio400Hinged from '../../assets/img/reviews/patio-400-hinged.svg';
import entryDoorSingle from '../../assets/img/reviews/entry-door-single.svg';
import patio200series from '../../assets/img/reviews/200-series.svg';
import aSeriesContemporaryHinged from '../../assets/img/reviews/a-series_contemporary_hinged.svg';
import bayAndBow from '../../assets/img/reviews/window-bay-and-bow.svg';
import { getBreakpoint, useCurrentScreenType } from 'lib/utils/get-screen-type';
import { useTheme } from 'lib/context/ThemeContext';
import { ReviewProductImageTheme } from './ReviewProductImage.Theme';

export type ReviewProductImageProps = {
  productName: string;
};

const ReviewProductImage = (props: ReviewProductImageProps) => {
  const { themeData } = useTheme(ReviewProductImageTheme);
  const { productName } = props;
  const { currentScreenWidth } = useCurrentScreenType();

  const isMobile = currentScreenWidth < getBreakpoint('md');
  const imageSize = isMobile ? 60 : 85;

  const getProductImage = () => {
    switch (productName) {
      case 'awning':
        return awning;
      case 'casement':
        return casement;
      case 'coastal':
      case 'double_hung':
        return doubleHung;
      case 'picture':
        return picture;
      case 'sliding':
        return sliding;
      case 'specialty':
        return specialty;
      case 'a-series_traditional_sliding':
      case 'a-series_contemporary_sliding_stormwatch':
      case 'a-series_traditional_sliding_stormwatch:':
      case 'patio_doors':
      case 'a-series_contemporary_sliding':
      case '400':
      case '400_sliding':
        return patio400Sliding;
      case 'a-series_traditional_hinged_stormwatch':
      case 'a-series_traditional_hinged':
      case '400_hinged':
        return patio400Hinged;
      case 'entry_door':
        return entryDoorSingle;
      case '200_narroline':
      case '200_perma-shield':
        return patio200series;
      case 'a-series_contemporary_hinged_stormwatch':
      case 'a-series_contemporary_hinged':
        return aSeriesContemporaryHinged;
      case 'bay_and_bow':
        return bayAndBow;
      default:
        return '';
    }
  };

  const imageSrc = getProductImage();
  if (imageSrc) {
    return (
      <div className={themeData.classes.productImage}>
        <Image src={getProductImage()} alt={productName} width={imageSize} height={imageSize} />
      </div>
    );
  } else {
    return <></>;
  }
};

export default ReviewProductImage;
